import React from 'react';
import smlmImage from "./images/smlmIllustration.png";
import tubulins from "./images/tubulins.gif";
import renderingImage from "./images/challenge2016.png"
import fft_image from "./images/FFT_of_smlmIllustration.png"
import softIllus from './images/softwareIllustration.svg';


class HomePage extends React.Component {

    renderElement(cardName,route, imgUrl) {
        return ( 
                <a className="card link-trapeze-horizontal" onClick={() => this.props.history.push(route)}
                 style={{"maxWidth":"250px"}}>
                    <picture className="card-img-top">
                        <img src={imgUrl} className="img-fluid" title="" alt="" />
                    </picture>
                    <div className="card-body">
                        <h3 className="card-title">{cardName}</h3>
                    </div>
                </a>
        );
    }

    render() {
        return (
        <div style={{textAlign:"center"}}>
            <div className="card-deck" style={{"justifyContent":"center"}}>
                {this.renderElement("Super-Resolution Microscopy software database",'/SoftwareList',softIllus)}
                {this.renderElement("Online SMLM rendering tool",'/smlmPreview',renderingImage)}
                {this.renderElement("SMLM Challenge leaderboard",'/Challenge',tubulins)}
                {this.renderElement("Assessment metrics for Super-Resolution Microscopy",'/Metrics',fft_image)}
                {this.renderElement("Super-Resolution Microscopy datasets",'/Datasets',smlmImage)}
            </div>
        </div>
      );
    }
}

export default HomePage;